import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions} from "../../constants";

export default class TubSpout extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'tub_spout';
    this.partName = 'Tub Spout';
    this.translateId = "visualizer.bathroom.shower.tub_spout";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  hideLayerCondition() {
    const showerComboParent = this.getParent();
    const showerParent = showerComboParent.layout.parts[Shower.id];
    if (!showerParent.showerTubComboIsActive() || showerComboParent.bottomTub !== "replacement_tub") {
      return true
    }
    if (showerParent.showerFixture && showerParent.showerFixture.activeFeature && showerParent.showerFixture.activeFeature.metaData["MountType"]
      && showerParent.showerFixture.activeFeature.metaData["MountType"].includes("T")) { // S and 0 is ok
      return true;
    }
    return false
  }

  getArrayOfConditions() {
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerSize = showerParent.showerSize();
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    return conditions
  }

  canDisplayDemoPoint() {
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerComboParent = layout.parts[ShowerTubCombo.id];
    return showerParent.showerTubComboIsActive() && showerComboParent.bottomTub === "replacement_tub";
  }

  showLayerPositionsModal() {
    return true
  }

}
